import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { useMemo } from 'react';
import UAParser from 'ua-parser-js';

const getBrowserLogoUrl = (browser: string | undefined): string | undefined => {
  switch (browser) {
    case 'Chrome':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/chrome/chrome_48x48.png';
    case 'Android Browser':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/android-webview/android-webview_48x48.png';
    case 'Edge':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/edge/edge_48x48.png';
    case 'Firefox':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/firefox/firefox_48x48.png';
    case 'Firefox [Reality]':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/firefox-reality/firefox-reality_48x48.png';
    case 'IE':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/internet-explorer_9-11/internet-explorer_9-11_48x48.png';
    case 'Opera':
      return 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/70.1.0/opera/opera_48x48.png';
    default:
      return undefined;
  }
};

export const FormatUserAgent: FC<{ agent: string | undefined }> = ({
  agent,
}) => {
  const parsed = useMemo(() => UAParser(agent), [agent]);

  if (!parsed?.browser?.name) {
    return (
      <Typography color="text.secondary" sx={{ fontSize: '0.8rem' }}>
        {agent}
      </Typography>
    );
  }

  const browserUrl = getBrowserLogoUrl(parsed.browser.name);

  return (
    <Stack direction={{ md: 'row', xs: 'column' }} spacing={{ md: 1, xs: 0 }}>
      <Stack direction="row" spacing={1}>
        <Typography color="text.secondary">OS</Typography>
        <Typography>{parsed.os.name}</Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Typography color="text.secondary">Browser</Typography>
        {browserUrl && (
          <img
            alt={parsed.browser.name}
            src={browserUrl}
            style={{ height: '1.2rem', width: '1.2rem' }}
          />
        )}
        <Typography>{parsed.browser.name}</Typography>
      </Stack>
    </Stack>
  );
};
